const scheduleTypes = {
  STANDARD: 'News',
  EVENT: 'Event',
  OFFER: 'Offer',
  ALERT: 'Covid-19',
  EDITIMAGES: 'Edit Images',
  EDITGENERAL: 'General Info',
  UNSPECIFIED: 'Unspecified',
}

Object.freeze(scheduleTypes)

export { scheduleTypes }
